export default {
    install(Vue) {
        Vue.mixin({
            data(){
                return {
                    clickBtuuonRepeat: false,
                    isShowArr: ['rj.yzhzkj.top','rj.njlhg.com'],
                    isShowArrData:[
                        {url:'rj.yzhzkj.top',lxr:'严老师',phone:'15026448220 ',site:'江苏省南京市江北新区葛塘街道宁六路349号3026-5室',name:'扬州市汇洲科技有限公司南京分公司'},
                        {url:'rj.njlhg.com',lxr:'陈老师',phone:'15026448220 ',site:'江苏省南京市浦口区桥林街道西街湾6号1幢104室-2',name:'南京蓝弘广网络科技有限公司'},
                    ],
                    footerCompany: ['rj.yzhzkj.top','rj.njlhg.com'],
                    matchHostArr : [
                        { host: 'rj.yzhzkj.top', name: '扬州市汇洲科技有限公司南京分公司' },
                        { host: 'rj.njlhg.com', name: '南京蓝弘广网络科技有限公司' },
                      ],
                }
            },
            methods:{

                //将url转成对象
                parseQueryString(url) {
                    //url参数转对象
                    url = !url ? window.location.href : url
                    if (url.indexOf('?') === -1) {
                    return null
                    }
                    let search = url[0] === '?' ? url.substr(1) : url.substring(url.lastIndexOf('?') + 1)
                    if (search === '') {
                    return null
                    }
                    search = search.split('&')
                    let query = {}
                    for (let i = 0; i < search.length; i++) {
                    let pair = search[i].split('=')
                    // query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '')
                    query[pair[0]] = pair[1] || ''
                    }
                    return query
                },

                isToPdf(){

                }
            }
        })
    }
}